export default function SequenceSetNumberOfBarsAction(actionContext, payload) {
	return actionContext.dispatch('SEQUENCE_SET_NUMBER_OF_BARS', payload);
}